import { trimPrice } from './tool';

const convert = (price, currentCurrency, originalCurrency, currencies = []) => {
    const crate = 1; // cyrille
    if (currencies.length === 0) {
        return price;
    }

    const originalRate = currencies.find(
        (c) => c.code === originalCurrency,
    )?.rate;
    const currentRate = currencies.find(
        (c) => c.code === currentCurrency,
    )?.rate;

    if (!originalRate) {
        return price;
    }

    if (!currentRate) {
        return price;
    }

    if (originalCurrency === currentCurrency) {
        return price;
    } else if (originalCurrency === 'EUR') {
        return trimPrice(parseFloat(price * currentRate, 2));
    } else if (currentCurrency === 'EUR') {
        const invertRate = 1 / originalRate;
        return trimPrice(parseFloat(price * invertRate, 2));
    } else {
        // on convertit le prix en euro
        const trate = 1 / originalRate;
        const europrice = price * trate;

        // on convertit le prix en current currency
        return trimPrice(parseFloat(europrice * currentRate, 2));
    }
};

export default convert;
